import { ICreateAAMembershipPageModel } from '../../../../../../models/interfaces/Membership/AirAmbulance/CreateAAMembershipPageModel';

export const checkFamilyMembersFormVisible = (
  values: ICreateAAMembershipPageModel,
) =>
  values &&
  values.membershipPlanId &&
  values.membershipPlanId.maxMembersPerPlan > 1;
